module.exports = __webpack_public_path__ + "img/icon-email-new.5b8bf593.png";